/**
 * @flow
 * @relayHash 1d33344ce87a59c4c616eec7d29557dd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WMMobileTopSubscriptionVariables = {|
  event_id: string,
  quarter_id: string,
|};
export type WMMobileTopSubscriptionResponse = {|
  +golfLeaderboardFindEventById: ?{|
    +event_id: ?number,
    +quarter_id: ?number,
  |}
|};
export type WMMobileTopSubscription = {|
  variables: WMMobileTopSubscriptionVariables,
  response: WMMobileTopSubscriptionResponse,
|};
*/


/*
subscription WMMobileTopSubscription(
  $event_id: ID!
  $quarter_id: ID!
) {
  golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id) {
    event_id
    quarter_id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "quarter_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "golfLeaderboardFindEventById",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event_id",
        "variableName": "event_id"
      },
      {
        "kind": "Variable",
        "name": "quarter_id",
        "variableName": "quarter_id"
      }
    ],
    "concreteType": "updateGolfLeadarboardType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "event_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "quarter_id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "WMMobileTopSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "WMMobileTopSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "WMMobileTopSubscription",
    "id": null,
    "text": "subscription WMMobileTopSubscription(\n  $event_id: ID!\n  $quarter_id: ID!\n) {\n  golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id) {\n    event_id\n    quarter_id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dbf6a4732853829e7dfc393179e18098';
module.exports = node;
